(($, window, undefined) => {
  if (window.mg === undefined)
    window.mg = {};

  if (window.mg.ui === undefined)
    window.mg.ui = {};

  const _ = window.mg;

  const selector = {
    FIXED_CONTENT  : '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top, .header:not(.header-sticky-absolute)',
    STICKY_CONTENT : '.sticky-top'
  };

  class Navigation {
    constructor() {
      this._navigation        = null;
      this._header            = null;
      this._backdrop          = null;
      this._isShown           = false;
      this._isBodyOverflowing = false;
      this._scrollbarWidth    = 0;
    }

    init(navigation, header) {
      this._navigation = $(navigation);
      this._header     = $(header);

      let resizeTimeOutId;
      let windowW = window.innerWidth;

      $(window)
        .on('resize.ui-navigation orientationchange.ui-navigation', () => {
          if (!this._isShown || window.innerWidth === windowW) return;

          windowW = window.innerWidth;

          if (resizeTimeOutId) clearTimeout(resizeTimeOutId);

          resizeTimeOutId = setTimeout(() => {
            this._setTopPosition();
          }, 100);
        });
    }

    show() {
      this._isShown = true;

      this._checkScrollbar();
      this._setScrollbar();
      this._showBackdrop();
      this._setTopPosition();

      $(document.body).addClass('navigation-open');
    }

    hide() {
      this._isShown = false;

      this._resetScrollbar();
      this._removeBackdrop();

      $(document.body).removeClass('navigation-open');
    }

    toggle() {
      if (this._isShown)
        this.hide();
      else
        this.show();
    }

    itemClick(target, func) {
      if (target.getAttribute('disabled') === 'disabled') {
        _.showInactiveMembershipInfo();
      } else {
        if ($.isFunction(func))
          func();
        else if (typeof func === 'string')
          eval(func);
      }

      this.toggle();
    }

    _checkScrollbar() {
      const rect = document.body.getBoundingClientRect();

      this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
      this._scrollbarWidth    = _.getScrollbarWidth();
    }

    _setScrollbar() {
      const $body = $(document.body);

      if (this._isBodyOverflowing) {
        const fixedContent  = [].slice.call(document.querySelectorAll(selector.FIXED_CONTENT));
        const stickyContent = [].slice.call(document.querySelectorAll(selector.STICKY_CONTENT));

        $(fixedContent).each((index, element) => {
          const actualPadding     = element.style.paddingRight;
          const calculatedPadding = $(element).css('padding-right');

          $(element)
            .data('padding-right', actualPadding)
            .css('padding-right', `${parseFloat(calculatedPadding) + this._scrollbarWidth}px`);
        });

        $(stickyContent).each((index, element) => {
          const actualMargin     = element.style.marginRight;
          const calculatedMargin = $(element).css('margin-right');

          $(element)
            .data('margin-right', actualMargin)
            .css('margin-right', `${parseFloat(calculatedMargin) - this._scrollbarWidth}px`);
        });

        const bodyActualPadding     = document.body.style.paddingRight;
        const bodyCalculatedPadding = $body.css('padding-right');

        $body
          .data('padding-right', bodyActualPadding)
          .css('padding-right', `${parseFloat(bodyCalculatedPadding) + this._scrollbarWidth}px`);
      }
    }

    _resetScrollbar() {
      const fixedContent  = [].slice.call(document.querySelectorAll(selector.FIXED_CONTENT));
      const stickyContent = [].slice.call(document.querySelectorAll(selector.STICKY_CONTENT));

      $(fixedContent).each((index, element) => {
        const padding = $(element).data('padding-right');

        $(element).removeData('padding-right');
        element.style.paddingRight = padding ? padding : '';
      });

      $(stickyContent).each((index, element) => {
        const margin = $(element).data('margin-right');

        $(element).removeData('margin-right');
        element.style.marginRight = margin ? margin : '';
      });

      const $body       = $(document.body);
      const bodyPadding = $body.data('padding-right');

      $body.removeData('padding-right');
      document.body.style.paddingRight = bodyPadding ? bodyPadding : '';
    }

    _showBackdrop() {
      this._backdrop = $('<div class="navigation-backdrop"></div>');
      this._backdrop.on('click', () => {
        this.hide();
      });

      $(document.body).append(this._backdrop);
    }

    _removeBackdrop() {
      if (this._backdrop) {
        this._backdrop.remove();
        this._backdrop = null;
      }
    }

    _setTopPosition() {
      let top = this._header[0].getBoundingClientRect().height - $(window).scrollTop();

      if (!this._header.hasClass('header-sticky-absolute')) {
        top = $('.header-bar', this._header)[0].getBoundingClientRect().height;
      }

      this._navigation.css('top', top);
      this._backdrop.css('top', top);
    }
  }

  _.ui.navigation = new Navigation();
})(jQuery, window);
